export const generateHexNumber = (length: number) => {
  const result: string[] = [];
  const hexRef = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F'];
  for (let i = 0; i < length; i += 1) {
    result.push(hexRef[Math.floor(Math.random() * 16)]);
  }

  return result.join('');
};
